import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Query, Mutation } from 'react-apollo'
import { message } from 'antd'
import {
  Div, H3, ButtonForm, LoadingIcon,
} from 'konsys-ui'
import { CenterContainerMsg, CenterContainerWentWrongMsg } from '../common/container-msg'
import { Step2 } from '../../pages/quotation-request'
import { theme } from '../../styles/_variables'
import { GET_PROFILE } from '../../constants/graph/query'
import { EDIT_PROFILE } from '../../constants/graph/mutation'
import VALIDATE from '../../constants/validate'

const EditProfile = ({ defaultData, refetch }) => {
  const [disabledButton, setDisabledButton] = useState(false)
  const [loadingButton, setLoadingButton] = useState(false)
  const [userData, setUserData] = useState({
    newShipData: defaultData && defaultData.newShipData ? 'newShipData' : '',
    taxData: defaultData ? defaultData.address : {},
    shipData: defaultData && defaultData.newShipData ? defaultData.shippingAddress : {},
    detail: '',
  })

  const step2RequireField = [
    'userName',
    'userSurname',
    'email',
    'addressNumber',
    'district',
    'subDistrict',
    'province',
    'postalCode',
    'mobileNumber',
  ]
  const [withHoldingTax, setWithHoldingTaxRate] = useState(0)

  useEffect(() => {
    const objectData = userData.newShipData ? ['taxData', 'shipData'] : ['taxData']
    loop1: //eslint-disable-line
    for (let y = 0; y < objectData.length; y += 1) {
      const parentName = objectData[y]
      if (!_.isEmpty(userData[objectData[y]])) {
        for (let i = 0; i < step2RequireField.length; i += 1) {
          if (
            _.filter(Object.keys(userData[parentName]), d => d === step2RequireField[i]).length === 0
            || ((step2RequireField[i] !== 'postalCode' || step2RequireField[i] !== 'email') && userData[parentName][step2RequireField[i]] === '')
            || (step2RequireField[i] === 'postalCode' && (userData[parentName].postalCode === 0 || userData[parentName].postalCode.length !== 5))
            || (step2RequireField[i] === 'email' && !VALIDATE.email.test(userData[parentName].email))
            || (step2RequireField[i] === 'mobileNumber' && userData[parentName].mobileNumber.length !== 10)
          ) {
            setDisabledButton(true)
            break loop1 //eslint-disable-line
          } else {
            setDisabledButton(false)
          }
        }
      } else {
        setDisabledButton(true)
        break loop1 //eslint-disable-line
      }
    }
  })

  return (
    <Div margin='0 -16px'>
      <H3 display='block' margin='0 16px' bold color={theme.color.tertiaryColor}>แก้ไขข้อมูลส่วนตัว</H3>
      <Step2
        hideNotes
        smallTitle
        disabledEmail
        setWithHoldingTaxRate={setWithHoldingTaxRate}
        data={userData}
        onChangeData={(data, name, parentName) => {
          const newData = Object.assign({}, userData)
          if (parentName) {
            newData[parentName][name] = data
          } else {
            newData[name] = data
          }
          setUserData(newData)
        }}
      />
      <Mutation
        mutation={EDIT_PROFILE}
      >
      {
        doEditProfile => (
          <ButtonForm
            color={theme.color.secondaryColor}
            inverse
            text='ยืนยันการแก้ไข'
            buttonStyle='round'
            display='block'
            margin='0 auto'
            disabled={disabledButton}
            loading={loadingButton}
            onClick={() => {
              setDisabledButton(true)
              setLoadingButton(true)
              const input = Object.assign({}, _.omit(userData.taxData, ['addressId', 'email', '__typename']))
              input.isSameAddress = !userData.newShipData
              Object.keys(_.omit(userData.shipData, ['addressId', '__typename'])).forEach((key) => {
                const removeStringInKey = key.charAt(0).toUpperCase() + key.slice(1)
                const newKey = `shipping${removeStringInKey}`
                input[newKey] = userData.shipData[key]
              })
              doEditProfile({
                variables: {
                  input,
                },
              }).then((resp) => {
                if (resp.data.editProfile) {
                  if (resp.data.editProfile.success) {
                    message.success(resp.data.editProfile.message)
                    setTimeout(() => {
                      refetch()
                    }, 3000)
                  } else {
                    message.error(resp.data.editProfile.message)
                  }
                  setDisabledButton(false)
                  setLoadingButton(false)
                }
              })
            }}
          />
        )
      }
      </Mutation>
    </Div>
  )
}

const QueryEditProfile = props => (
  <Query
    query={GET_PROFILE}
  >
  {
    ({ loading, data, refetch }) => {
      if (loading || !data) {
        return <CenterContainerMsg>
          <LoadingIcon color={theme.color.lightPaleGrey} />
        </CenterContainerMsg>
      }
      if (!data.showProfile.success) {
        message.error(data.showProfile.message)
        return <CenterContainerWentWrongMsg title='ระบบมีปัญหา กรุณาลองใหม่ภายหลัง' />
      }
      const newProfile = {
        address: {},
        shippingAddress: {},
        newShipData: !data.showProfile.isSameAddress,
      }
      newProfile.address = Object.assign(data.showProfile.profile.address, {
        mobileNumber: data.showProfile.profile.address.mobileNumber.replace(/-/g, ''),
        telephoneNumber: data.showProfile.profile.address.telephoneNumber.replace(/-/g, ''),
      })
      Object.keys(data.showProfile.profile.shippingAddress).forEach((key) => {
        let removeStringInKey = key.replace(/shipping/g, '')
        removeStringInKey = removeStringInKey.charAt(0).toLowerCase() + removeStringInKey.slice(1)
        if ((removeStringInKey === 'mobileNumber' || removeStringInKey === 'telephoneNumber') && data.showProfile.profile.shippingAddress[key]) {
          data.showProfile.profile.shippingAddress[key].replace(/-/g, '')
        }
        newProfile.shippingAddress[removeStringInKey] = data.showProfile.profile.shippingAddress[key]
      })
      if (props.children) {
        const children = React.Children.map(props.children, (child, index) => (
          React.cloneElement(child, {
            index,
            profileData: newProfile,
          })
        ))
        return children
      }
      return (
        <EditProfile
          defaultData={newProfile}
          refetch={() => refetch()}
        />
      )
    }
  }
  </Query>
)

export default QueryEditProfile



// WEBPACK FOOTER //
// ./src/components/profile/index.jsx